<script>
    import Nav from './Nav.svelte'
	import { _ } from '../../services/i18n';

	let ekmonlogosmall = 'images/ekmon.png';
	
</script>


<div id="homepage" class="home">


    <Nav/>
	<div class="softwarewrapper">

		<img src={ekmonlogosmall} alt="ekmon logo"  class="ekmonLogoSmall">
	</div>

</div>


<style>

	.home {
		background-position: -100px -500px;
        background-image: url('../images/forest.jpg');
        height: 100%;
		margin: 0 auto;
        background-repeat: no-repeat;
		text-align: center;
	}

	h1 {
		font-size: 2.9em;
    	color: white;
    	font-family: Helvetica, sans-serif;
    	font-weight: 'light';
		
	}
	h2 {
		font-size: 2.6em;
    	color:white;
    	font-family: 'Oswald';
    	font-weight:bold;
		
	}
	.mainheader {
		margin-top: 0px;
		margin-bottom: 0px;
		margin-left: 0px;
		margin-right: 0px;
		display:flex;
		text-align: center;	
		
	}
	.softwareheader {
		padding-left: 16px;
		letter-spacing: 0.42em;
		line-height: 44px; 
		color: #E56B6F;
	}
	.softwarewrapper{
		border-width: 2px;
		border-style:solid;
		border-color: grey;
		background-color: white;
		margin: 0 auto;
		text-align: center;		
		padding: 16px;
		display: flex;
		flex-direction: column;
		align-items: center;
		width:284px;
		
	}
	.ekmonLogoSmall {
		/* display: none; */
		width: 250px;
	}

	@media (min-width: 1366px) {

		.ekmonLogoSmall {
		display: block
		}

		.home {
		background-position: 0px 0px;
		}
        div {	
        background-size: 100%;	
		}

		.softwarewrapper {
		margin-top:14% ;
		background-color: white;
		border-color: grey;

		}
	}
	@media (min-height: 1024px) {
		.home {
			background-position: 0px 0px;
			height: 1080px;
		}
	}
</style>